import { render, staticRenderFns } from "./AssignedMembers.vue?vue&type=template&id=6bdf77a0&scoped=true"
import script from "./AssignedMembers.vue?vue&type=script&lang=js"
export * from "./AssignedMembers.vue?vue&type=script&lang=js"
import style0 from "./AssignedMembers.vue?vue&type=style&index=0&id=6bdf77a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdf77a0",
  null
  
)

export default component.exports